export enum PackageItemItemType {
    PackageItem = "package_item",
    Upsell = "upsell",
    Credit = "credit",
    BasePrice = "base_price",
    Competition = "competition",
}
